<template>
    <div class="column">
        <div class="col-12 col-md-12 p-0">
            <div class="form-group">
                <label for="member-id"> Member ID <span class="text-danger">*</span> </label>
                <input
                    class="form-control"
                    maxlength="50"
                    name="member-id"
                    type="text"
                    placeholder="Enter Member ID"
                    v-model="referral.Referral[insurer?.memberID]"
                    @blur="v$.referral.Referral[insurer?.memberID].$touch"
                    :class="`${!v$.referral.Referral[insurer?.memberID].$error ? '' : 'field-invalid'}`"
                />
                <span v-if="v$.referral.Referral[insurer?.memberID].$error" class="field-invalid">
                    Member ID is required.</span
                >
            </div>
            <div class="form-group">
                <label for="group-name"> Group Name </label>
                <input
                    class="form-control"
                    maxlength="50"
                    name="group-name"
                    type="text"
                    placeholder="Enter Group Name"
                    v-model="referral.Referral[insurer?.groupName]"
                />
            </div>
            <div class="form-group">
                <label for="group-id"> Group ID </label>
                <input
                    class="form-control"
                    maxlength="50"
                    name="group-id"
                    type="text"
                    placeholder="Enter Group ID"
                    v-model="referral.Referral[insurer?.groupID]"
                />
            </div>
            <div class="form-group">
                <label for="relationship-to-insured">
                    Relationship to Insured
                    <span class="text-danger">*</span>
                </label>
                <select class="form-select" name="relationship-to-insured" v-model="relationshipInsuredTo">
                    <option :value="2">18-Self</option>
                    <option
                        v-for="[key, value] of enumToMap(relationshipToInsuredEnum)"
                        :key="key"
                        :value="value.value"
                    >
                        {{ value.name }}
                    </option>
                </select>
            </div>
            <div v-if="referral && referralOptions && relationshipInsuredTo !== null && relationshipInsuredTo !== 2">
                <div class="form-group">
                    <label for="insured-first-name"> Insured First Name </label>
                    <input
                        class="form-control"
                        maxlength="50"
                        name="insured-first-name"
                        type="text"
                        placeholder="Enter Insured First Name"
                        v-model="referral.Referral.AdditionalBillingInfo[insurer.details].FirstName"
                    />
                </div>
                <div class="form-group">
                    <label for="insured-middle-name"> Insured middle Name </label>
                    <input
                        class="form-control"
                        maxlength="50"
                        name="insured-middle-name"
                        type="text"
                        placeholder="Enter Insured Middle Name"
                        v-model="referral.Referral.AdditionalBillingInfo[insurer.details].MiddleInitial"
                    />
                </div>
                <div class="form-group">
                    <label for="insured-last-name"> Insured last Name </label>
                    <input
                        class="form-control"
                        maxlength="50"
                        name="insured-last-name"
                        type="text"
                        placeholder="Enter Insured last Name"
                        v-model="referral.Referral.AdditionalBillingInfo[insurer.details].LastName"
                    />
                </div>
                <div class="form-group">
                    <label for="insured-date-of-birth"> Date of Birth </label>
                    <DatePicker :getDate="onDateChange">
                        <div class="input-group date datepickerInput">
                            <input
                                type="text"
                                name="insured-date-of-birth"
                                class="form-control"
                                placeholder="MM/DD/YYYY"
                                autocomplete="off"
                                v-model="referral.Referral.AdditionalBillingInfo[insurer.details].InsuredDateOfBirth"
                            />
                            <div class="input-group-addon input-group-append">
                                <div class="input-group-text">
                                    <i class="fa fa-calendar"></i>
                                </div>
                            </div>
                        </div>
                    </DatePicker>
                </div>
                <div class="form-group">
                    <label id="insured_Gender_Label" for="insured-gender"> Gender </label>
                    <select
                        id="Insured_Gender"
                        class="form-select"
                        name="insured-gender"
                        v-model="referral.Referral.AdditionalBillingInfo[insurer.details].InsuredGender"
                    >
                        <option value="">Select Gender</option>
                        <option v-for="(gender, index) of referralOptions.gender" :key="index" :value="gender.text">
                            {{ gender.text }}
                        </option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="address-line-one">Address Line 1 </label>
                    <input
                        class="form-control"
                        maxlength="50"
                        name="address-line-one"
                        type="text"
                        v-model="referral.Referral.AdditionalBillingInfo[insurer.details].Address.AddressLine1"
                        placeholder="Enter Address"
                    />
                </div>
                <div class="form-group">
                    <label for="address-line-two">Address Line 2 </label>
                    <input
                        v-model="referral.Referral.AdditionalBillingInfo[insurer.details].Address.AddressLine2"
                        class="form-control"
                        maxlength="50"
                        name="address-line-two"
                        type="text"
                        placeholder="Enter Address"
                    />
                </div>
                <div class="form-group">
                    <label for="address-city">Address City </label>
                    <input
                        v-model="referral.Referral.AdditionalBillingInfo[insurer.details].Address.AddressCity"
                        class="form-control"
                        maxlength="50"
                        name="address-city"
                        type="text"
                        placeholder="Enter City"
                    />
                </div>
                <div class="form-group">
                    <label for="address-state">State </label>
                    <input
                        v-model="referral.Referral.AdditionalBillingInfo[insurer.details].Address.AddressState"
                        class="form-control"
                        maxlength="50"
                        name="address-state"
                        type="text"
                        placeholder="Enter state"
                    />
                </div>
                <div class="form-group">
                    <label for="address-zip">Zip </label>
                    <input
                        v-model="referral.Referral.AdditionalBillingInfo[insurer.details].Address.AddressStateCode"
                        class="form-control"
                        maxlength="5"
                        name="address-zip"
                        type="text"
                        placeholder="Enter zip"
                    />
                </div>
                <div class="form-group">
                    <label for="address-zip4">Zip-4 </label>
                    <input
                        v-model="referral.Referral.AdditionalBillingInfo[insurer.details].Address.AddressZipFFour"
                        class="form-control"
                        maxlength="4"
                        name="address-zip4"
                        type="text"
                        placeholder="Enter Zip 4"
                    />
                </div>
            </div>
            <div class="form-group">
                <label for="employer-name"> Employer Name </label>
                <input
                    class="form-control"
                    maxlength="50"
                    name="employer-name"
                    type="text"
                    v-model="referral.Referral.AdditionalBillingInfo[insurer?.details].EmployerName"
                    placeholder="Enter Employer Name"
                />
            </div>
        </div>
        <div class="col-12 col-md-12 p-0">
            <div class="form-group">
                <label for="deductible-amount"> Deductible Amount </label>
                <input
                    class="form-control"
                    maxlength="50"
                    name="deductible-amount"
                    type="text"
                    placeholder="Enter Deductible Amount"
                    v-model="referral.Referral.AdditionalBillingInfo[insurer?.details].DeductibleAmount"
                    number-only="decimal"
                />
            </div>
            <div class="form-group d-flex flex-row justify-content-between">
                <div class="form-check custom-checkbox form-check-inline mt-2">
                    <input
                        type="checkbox"
                        :id="insurer.details"
                        :name="insurer.details"
                        class="form-check-input au-target"
                        v-model="referral.Referral.AdditionalBillingInfo[insurer?.details].DeductibleMet"
                    />
                    <label class="form-check-label flex-grow-0" :for="insurer.details">
                        <span class="me-1">Deductible Met</span>
                    </label>
                </div>
            </div>
            <div class="form-group">
                <label for="copay-amount"> Copay Amount </label>
                <input
                    class="form-control"
                    maxlength="50"
                    id="copay-amount"
                    name="copay-amt"
                    type="text"
                    placeholder="Enter Copay Amount"
                    v-model="referral.Referral.AdditionalBillingInfo[insurer?.details].CopayAmount"
                />
            </div>
            <hr />
        </div>
    </div>
</template>

<script lang="ts" src="./NonMedicarePayorNew.ts"></script>
